import { Injectable } from "@angular/core";
import { IStepsModel, IMergedStepsModel } from "../../views-interfaces/steps-model.interface";
import { StepsSaveObject } from "../../views-interfaces/steps-save-model.interface";
import { IMergedStatusObjectModel, IStatusObjectModel } from "../../views-interfaces/status-object-model.interface";
import { compareSteps } from "@shared/steps-service";

@Injectable({ providedIn: "root" })
export class MappingOfStatusesService {
    Steps: IStepsModel[];
    MergedSteps: IMergedStepsModel[];
    NewModel = new StepsSaveObject();

    getStepFromStatusId(statusId: string): IStepsModel {
        return this.getStepByStatusId(statusId, "step");
    }

    getStatusFromStatusId(statusId: string): IStatusObjectModel {
        return this.getStepByStatusId(statusId, "status");
    }

    // Overloads provide precise return types depending on the returnType argument.
    private getStepByStatusId(statusId: string, returnType: "step"): IStepsModel | null;
    private getStepByStatusId(statusId: string, returnType: "status"): IStatusObjectModel | null;
    private getStepByStatusId(statusId: string, returnType: "step" | "status"): IStepsModel | IStatusObjectModel | null {
        for (const step of this.Steps ?? []) {
            const status = step.Statuses.find((s) => statusId === s.TaxReturnStatusId);
            if (status) {
                return returnType === "step" ? step : status;
            }
        }
        return null;
    }

    getAllReturnStatuses(): IMergedStatusObjectModel[] {
        const returnData: IMergedStatusObjectModel[] = [];
        this.MergedSteps.sort(compareSteps).forEach((step) => {
            step.Statuses.forEach((status) => {
                returnData.push(status);
            });
        });
        return returnData;
    }

    getStatusIdsFromStepId(stepId: string) {
        const step = this.Steps.find((x) => {
            return x.Id === stepId;
        });
        if (!step) {
            return [];
        }
        return step.Statuses.map((x) => {
            return x.TaxReturnStatusId;
        });
    }

    getAllStatusesOf(state: "notStarted" | "active" | "completed") {
        const applicableSortedSteps = this.MergedSteps.filter((step) => step.State === state && step.Statuses?.length > 0).sort(compareSteps);
        return applicableSortedSteps?.flatMap((step) => step.Statuses.map((status) => status.TaxReturnStatus));
    }

    /**
     * Returns the first applicable return status in a state
     */
    getFirstStatusOf(state: "notStarted" | "active" | "completed") {
        const applicableSortedSteps = this.MergedSteps.filter((step) => step.State === state && step.Statuses?.length > 0).sort(compareSteps);
        return applicableSortedSteps[0]?.Statuses[0]?.TaxReturnStatus;
    }
}
